import { useFlipperFlag } from './useFlipperFlag'
import { useIsVirtualMarketer } from './useIsVirtualMarketer'
import useResponsiveDesign from './useResponsiveDesign'
import { useIsOnboardingPath } from './useIsOnboardingPath'

export const useIsSystemRedesign = () => {
  const { isMobile } = useResponsiveDesign()
  const isVirtualMarketer = useIsVirtualMarketer()
  const isSystemRedesign = useFlipperFlag('system_redesign')
  const isOnboardingPath = useIsOnboardingPath()

  // Need to use the attribute because the flag is not always loaded in the signup and login flows
  const isSystemRedesignAttribute = document.documentElement.getAttribute('data-autopilot-system-redesign') === 'on'

  return isVirtualMarketer && !isMobile && (isSystemRedesign || (isOnboardingPath && isSystemRedesignAttribute))
}
